import { render, staticRenderFns } from "./p5s4contacts.vue?vue&type=template&id=51cbd354"
import script from "./p5s4contacts.vue?vue&type=script&lang=js"
export * from "./p5s4contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports